import type { FaireProductEntity } from "../../entity_types/product";

export const p_4tnc6zju82: FaireProductEntity = {
  token: "p_4tnc6zju82",
  type: "product",
  name: "Gold Plated Cross Crystal Necklace",
  brandToken: "b_y2j497tv82",
  brandName: "The Pretty Jewellery",
  imageUrl:
    "https://cdn.faire.com/fastly/4f09122560daad2ed3d4b52d7c9019f3c0e4ad03324d141f1cc49eae824e63b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a81d83452e8533dab2b3023b5a8ccf2e6100f37bd566ba84dc855cc81ab61403.jpeg",
  ],
  priceDollars: 4.43,
  description:
    "Cross Pendant\n\nShiny crystal design\n\nGold plating process\n\nCrystal and copper materials\n\nPendant size 1.8CM * 3.2CM\n\nNecklace length 40CM + 5CM",
  tags: [],
  msrpDollars: 9.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:56.540Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
